import { useMemo } from 'react';

const __settings = image_hub_settings;

export const getImageHubSettings = () => {
  const imageHubSettings = useMemo(() => {
    return {
      image_hub_api_keys_giphy_api_key: __settings.image_hub_api_keys_giphy_api_key,
      image_hub_api_keys_openverse_client_id: __settings.image_hub_api_keys_openverse_client_id,
      image_hub_api_keys_openverse_client_secret: __settings.image_hub_api_keys_openverse_client_secret,
      image_hub_api_keys_pexels_api_key: __settings.image_hub_api_keys_pexels_api_key,
      image_hub_api_keys_pixabay_api_key: __settings.image_hub_api_keys_pixabay_api_key,
      image_hub_api_keys_unsplash_access_key: __settings.image_hub_api_keys_unsplash_access_key,
      image_hub_enable_giphy: __settings.image_hub_enable_giphy === "1",  
      image_hub_enable_image_attribution: __settings.image_hub_enable_image_attribution === "1",  
      image_hub_enable_media_modal: __settings.image_hub_enable_media_modal === "1",  
      image_hub_enable_openverse: __settings.image_hub_enable_openverse === "1",  
      image_hub_enable_pexels: __settings.image_hub_enable_pexels === "1",  
      image_hub_enable_pixabay: __settings.image_hub_enable_pixabay === "1",  
      image_hub_enable_unsplash: __settings.image_hub_enable_unsplash === "1",
      image_hub_use_default_keys:__settings.image_hub_use_default_keys === "1",  
      image_hub_max_image_height: parseInt(__settings.image_hub_max_image_height, 10),  
      image_hub_max_image_width: parseInt(__settings.image_hub_max_image_width, 10),  
    };
  }, [__settings]);  

  const apiKeys = useMemo(() => {
    return {
      giphy_api_key: __settings.image_hub_api_keys_giphy_api_key,
      openverse_client_id: __settings.image_hub_api_keys_openverse_client_id,
      openverse_client_secret: __settings.image_hub_api_keys_openverse_client_secret,
      pexels_api_key: __settings.image_hub_api_keys_pexels_api_key,
      pixabay_api_key: __settings.image_hub_api_keys_pixabay_api_key,
      unsplash_access_key: __settings.image_hub_api_keys_unsplash_access_key,
      image_hub_use_default_keys:__settings.image_hub_use_default_keys === "1",  
  
    };
  }, [__settings]);  

  return { imageHubSettings,apiKeys, isLoading: false };
};
